import axios from 'axios';

const myPixabayKey = '55346190-4624957b91b7e155596749ae2';
const url = 'https://pixabay.com/api/';

export function getImagesByQuery(query) {
    const params = {
        key: myPixabayKey,
        q: query,
        image_type: 'photo',
        orientation: 'horizontal',
        safesearch: true,
    };
    return axios.get(url, { params: params })
        .then(response => {
            return response.data;
        });
}